module.exports = __webpack_public_path__ + "img/magento-migration_medium@2x.1af9ca7a.jpg";